export const msgError = {
    shift_name: { required: 'Tên ca làm việc là bắt buộc' },
    shift_code: { required: 'Mã ca làm việc là bắt buộc' },
    time_start: { required: 'Giờ làm bắt đầu là bắt buộc' },
    time_end: { required: 'Giờ làm kết thúc là bắt buộc' },
    numberofworkday: { required: 'Số công là bắt buộc' },
    time_checkin: { required: 'Giờ vào ca là bắt buộc' },
    time_checkout: { required: 'Giờ ra ca là bắt buộc' },
    model_error:['Bạn có thật sự muốn xóa?','Bạn sẽ mất dữ liệu này và các dữ liệu liên quan.']
}